import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import React from "react";
import * as ReactDOM from "react-dom";
var defaultRootElemSelector = "#portal-root";
var Portal = function(props) {
    var rootEl = props.rootElem || defaultRootElemSelector;
    var rootNode = typeof rootEl === "string" ? document.querySelector(rootEl) ? document.querySelector(rootEl) : document.body : rootEl;
    if (rootEl === document.body) {
        // eslint-disable-next-line no-console
        console.warn("Portal cannot find div:#portal-root in the document, using body instead");
    }
    var ref = _sliced_to_array(React.useState(function() {
        var el = document.createElement("div");
        el.classList.add("portal-element");
        return el;
    }), 1), container = ref[0];
    React.useEffect(function() {
        rootNode.append(container);
        return function() {
            container.remove();
        };
    }, [
        container,
        rootNode
    ]);
    return !props.children ? null : /*#__PURE__*/ ReactDOM.createPortal(props.children, container);
};
export default Portal;
